import appReducers from '../reducer/app';
import salesReducers from "../reducer/sales";
import iamReducers from "../reducer/iam";
import contentReducers from "../reducer/content";
import institutionReducers from "../reducer/institution";
import caseInfoReducers from "../reducer/caseInfo";
import collectionDateReducers from "../reducer/collectionDate";
import testDateReducers from "../reducer/testDate";
import testReportReducers from "../reducer/testReport";
import noReportReducers from "../reducer/noReport";
import positiveReportReducers from "../reducer/positiveReport";
import accountReducers from "../reducer/account";
import reportDateReducers from "../reducer/reportDate";
import approveOfIssuingReportReducers from "../reducer/approveOfIssuingReport";
import printReportListReducers from "../reducer/printReportList";
import reportUnlockReducers from "../reducer/reportUnlock";
import monthlyReportReducers from "../reducer/monthlyReport";

const rootReducer = {
    ...appReducers,
    ...iamReducers,
    ...salesReducers,
    ...contentReducers,
    ...institutionReducers,
    ...caseInfoReducers,
    ...collectionDateReducers,
    ...testDateReducers,
    ...testReportReducers,
    ...noReportReducers,
    ...positiveReportReducers,
    ...accountReducers,
    ...reportDateReducers,
    ...approveOfIssuingReportReducers,
    ...printReportListReducers,
    ...reportUnlockReducers,
    ...monthlyReportReducers,
};

export default rootReducer;
